import { Breadcrumb, Button } from "antd";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { _adr } from "../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import OprationResult from "../../auxiliary/opration/opration";
import { convertToJalaliWithoutTime } from "../../../tools/tools";

const CDFinal = () => {
	const [t] = useTranslation("global");
	const location = useLocation();
	return (
		<>
			<div className="container-main container-sp">
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("creditCard.title") }]}
					/>
					<div className="title-page">
						<h3>{t("creditCard.title")}</h3>
						<p></p>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className="g-layout-main sp-container">
						<div className="g-format-page">
							<div className="g-body-format-page">
								<OprationResult
									isSucess={true}
									list={[
										{
											label: "تاریخ و ساعت",
											value: (
												<>
													{/* <span dir="ltr">{convertToJalaliWithoutTime(location?.state?.swChange?.Date)}</span> */}
													<span dir="ltr">{convertToJalaliWithoutTime(new Date().toISOString())}</span>
												</>
											),
										},
										{
											label: "نوع سرویس",
											// value: location?.state?.swChange?.ServiceType,
										},
										{
											label: "شماره سیم کارت",
											// value: location?.state?.swChange?.MSISDN,
										},
										{
											label: "شماره کیت جدید",
											// value: location?.state?.swChange?.NEWICCID,
										},
										{
											label: "کد پیگیری",
											// value: location?.state?.swChange?.StrFollwUpCode,
										},
									]}
								/>
							</div>
							<div className="g-footer-format-page">
								<div className="holder-button">
									<Button
										className="btn-normal btn-print"
										onClick={() => {
											window.print();
										}}
										type="default"
										icon={<i className="icon-print"></i>}>
										چاپ رسید
									</Button>
								</div>
							</div>
						</div>
					</Content>
				</div>
			</div>
		</>
	);
};

export default CDFinal;
